import React from 'react';

import { EditionAwarenessUpsell as EditionAwarenessUpsellPlatform } from '@atlassian/edition-awareness/ui/edition-awareness-upsell';

import { useConfluenceStandardToPremiumExperiment } from './useConfluenceStandardToPremiumExperiment.tsx';

export const EditionAwarenessUpsell = ({ navVersion }: { navVersion?: 'nav3' | 'nav4' }) => {
	const { isEligibleForUpsellExperiment, ...rest } = useConfluenceStandardToPremiumExperiment();

	if (isEligibleForUpsellExperiment) {
		return <EditionAwarenessUpsellPlatform navVersion={navVersion} {...rest} />;
	}

	return null;
};
